import { t } from "@lingui/core/macro";

import React from "react";

import * as styles from "./Subscribe.module.scss";
import SubscribeInlineForm from "components/SubscribeToNewsletter/SubscribeInlineForm/SubscribeInlineForm";
import { BlockContentValue } from "@silversea-ssc/ui-components-react";
import { FormDisclaimerFragment } from "types/graphql-types";
import { INavLink } from "components/HeaderNavBar/type";
import { BlockContent } from "components/BlockContent";
import { isPresent } from "src/utils/checks";

// WARNING: this is needed because this component is used inside a gatby slice that doens't support lingui react
const generateLabel = () => {
  return t`Subscribe for exclusive <0/>offers and news`.replace(
    "<0/>",
    "<br />"
  );
};

type Props = {
  formTitle: string | BlockContentValue | undefined;
  formContent: BlockContentValue | undefined;
  footerContent: BlockContentValue | undefined;
  formDisclaimerContent: FormDisclaimerFragment | undefined;
  privacyPolicyUrl: INavLink;
  offerPageUrl: string | undefined;
};

const Subscribe: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const isPromoActive = isPresent(props.footerContent);

  return (
    <React.Fragment>
      <div className={styles.subscribe}>
        {isPromoActive ? (
          <>
            <div className={styles.titleWithPromo}>
              <label
                htmlFor="footer-subscribe-form"
                dangerouslySetInnerHTML={{ __html: generateLabel() }}
                aria-label={t`Subscribe for exclusive <0/>offers and news`}
              />
            </div>
            <div className={styles.subtitle}>
              <BlockContent value={props.footerContent} />
            </div>
          </>
        ) : (
          <div className={styles.title}>
            <label
              htmlFor="footer-subscribe-form"
              dangerouslySetInnerHTML={{ __html: generateLabel() }}
              aria-label={t`Subscribe for exclusive <0/>offers and news`}
            />
          </div>
        )}

        <SubscribeInlineForm
          formName="SubscribeToNewsletterFooter"
          formVariant="black"
          formButtonVariant="white"
          {...props}
        />
      </div>
    </React.Fragment>
  );
};

export default React.memo(Subscribe);
